"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transfersReducer = exports.initialState = void 0;
/* Package Imports */
var connected_react_router_1 = require("connected-react-router");
var immutable_1 = require("immutable");
var react_toastify_1 = require("react-toastify");
var typesafe_actions_1 = require("typesafe-actions");
/* Blast Imports */
var transfersActions = __importStar(require("./actions"));
var models_1 = require("./models");
var constants_1 = require("@app/shared/constants");
var api_1 = require("@server/types/api");
exports.initialState = {
    activeTransfers: [],
    asperaInstallVisible: false,
    asperaTransfers: immutable_1.OrderedMap(),
    asperaVersionBannerVisible: false,
    connectStatus: '',
    connectVersion: '',
    extensionInstallStatus: false,
    extensionInstallUrl: '',
    httpGatewayStatus: false,
    isLoadingRemoteFiles: false,
    isUploading: false,
    remoteFiles: [],
    selectedRemoteSource: -1,
    stagedFiles: []
};
var transfersReducer = function (state, action) {
    if (state === void 0) { state = exports.initialState; }
    switch (action.type) {
        // Transfers actions
        case typesafe_actions_1.getType(transfersActions.clearStagedFiles):
            return __assign(__assign({}, state), { stagedFiles: [], remoteFiles: [] });
        case typesafe_actions_1.getType(transfersActions.connectTransferCompleted):
            return __assign(__assign({}, state), { activeTransfers: state.activeTransfers.filter(function (t) { return t.requestId !== action.payload.requestId; }) });
        case typesafe_actions_1.getType(transfersActions.connectTransferReject):
            return __assign(__assign({}, state), { activeTransfers: state.activeTransfers.filter(function (t) { return t.requestId !== action.payload.requestId; }), transferErrorMessage: "Error with transfer of package. Resend and 'Allow' connection with Aspera Connect", transferSuccessMessage: undefined, isUploading: false });
        case typesafe_actions_1.getType(transfersActions.connectTransferStarted):
            return __assign(__assign({}, state), { stagedFiles: [], transferErrorMessage: undefined, transferSuccessMessage: action.payload.direction === api_1.Direction.SEND ? "Started transfer of package \"" + (action.payload.title || '') + "\"" : undefined, isUploading: false, activeTransfers: __spreadArray(__spreadArray([], state.activeTransfers), [{ requestId: action.payload.requestId, packageId: action.payload.packageId, direction: action.payload.direction, type: models_1.TransferType.CONNECT }]) });
        case typesafe_actions_1.getType(transfersActions.connectUploadReject):
            return __assign(__assign({}, state), { isUploading: false, transferErrorMessage: "Error with upload of package" });
        case typesafe_actions_1.getType(transfersActions.connectUploadRequest):
            return __assign(__assign({}, state), { isUploading: true });
        case typesafe_actions_1.getType(transfersActions.forwardPackageReject):
            return __assign(__assign({}, state), { isUploading: false });
        case typesafe_actions_1.getType(transfersActions.forwardPackageRequest):
            return __assign(__assign({}, state), { isUploading: true });
        case typesafe_actions_1.getType(transfersActions.forwardPackageSuccess):
            return __assign(__assign({}, state), { stagedFiles: [], transferSuccessMessage: "Started transfer of package \"" + action.payload.title + "\"", isUploading: false });
        case typesafe_actions_1.getType(transfersActions.gatewayTransferCompleted):
            return __assign(__assign({}, state), { activeTransfers: state.activeTransfers.filter(function (t) { return t.requestId !== action.payload.requestId; }), isUploading: false });
        case typesafe_actions_1.getType(transfersActions.gatewayTransferFailed):
            return __assign(__assign({}, state), { activeTransfers: state.activeTransfers.filter(function (t) { return t.requestId !== action.payload.requestId; }), transferErrorMessage: undefined, transferSuccessMessage: undefined, isUploading: false });
        case typesafe_actions_1.getType(transfersActions.gatewayTransferReject):
            return __assign(__assign({}, state), { activeTransfers: state.activeTransfers.filter(function (t) { return t.requestId !== action.payload.requestId; }), transferErrorMessage: "Error creating package, please re-attach your files and send again", transferSuccessMessage: undefined, isUploading: false });
        case typesafe_actions_1.getType(transfersActions.gatewayTransferStarted):
            return __assign(__assign({}, state), { isUploading: false, stagedFiles: [], transferErrorMessage: undefined, transferSuccessMessage: action.payload.direction === api_1.Direction.SEND ? "Started transfer of package \"" + (action.payload.title || '') + "\"" : undefined, activeTransfers: __spreadArray(__spreadArray([], state.activeTransfers), [{ requestId: action.payload.requestId, packageId: action.payload.packageId, direction: action.payload.direction, type: models_1.TransferType.GATEWAY }]) });
        case typesafe_actions_1.getType(transfersActions.hideAsperaInstall):
            return __assign(__assign({}, state), { asperaInstallVisible: false });
        case typesafe_actions_1.getType(transfersActions.hideAsperaVersionBanner):
            return __assign(__assign({}, state), { asperaVersionBannerVisible: false });
        case typesafe_actions_1.getType(transfersActions.httpUploadReject):
            return __assign(__assign({}, state), { isUploading: false });
        case typesafe_actions_1.getType(transfersActions.httpUploadRequest):
            return __assign(__assign({}, state), { isUploading: true });
        case typesafe_actions_1.getType(transfersActions.httpUploadSuccess): {
            return __assign(__assign({}, state), { transferErrorMessage: undefined, transferSuccessMessage: "Started transfer of package \"" + action.payload.title + "\"", stagedFiles: [], isUploading: false });
        }
        case typesafe_actions_1.getType(transfersActions.getRemoteFilesRequest): {
            if (action.payload.offset === 0) {
                return __assign(__assign({}, state), { isLoadingRemoteFiles: true, remoteFiles: [], selectedRemoteSource: action.payload.sourceId });
            }
            return __assign({}, state);
        }
        case typesafe_actions_1.getType(transfersActions.getRemoteFilesSuccess):
            return __assign(__assign({}, state), { isLoadingRemoteFiles: false, remoteFiles: __spreadArray(__spreadArray([], state.remoteFiles), action.payload) });
        case typesafe_actions_1.getType(transfersActions.pluginEvent):
            return __assign(__assign({}, state), { connectStatus: action.payload });
        case typesafe_actions_1.getType(transfersActions.remoteTransferReject):
            return __assign(__assign({}, state), { isUploading: false });
        case typesafe_actions_1.getType(transfersActions.remoteTransferRequest):
            return __assign(__assign({}, state), { isUploading: true });
        case typesafe_actions_1.getType(transfersActions.remoteTransferSuccess): {
            return __assign(__assign({}, state), { transferSuccessMessage: "Started transfer of package \"" + action.payload.title + "\"", stagedFiles: [], isUploading: false });
        }
        case typesafe_actions_1.getType(transfersActions.removeFile): {
            var newStagedFiles = state.stagedFiles.filter(function (f) { return f.filename !== action.payload.filename; });
            return __assign(__assign({}, state), { stagedFiles: newStagedFiles });
        }
        case typesafe_actions_1.getType(transfersActions.selectFiles): {
            // only add new files/folders to state
            var newlySelectedFiles = action.payload.filter(function (f) { return state.stagedFiles.findIndex(function (s) { return s.filename === f.filename; }) === -1; });
            if (newlySelectedFiles.length !== action.payload.length) {
                react_toastify_1.toast.warning("Cannot upload file(s) with the same name.\nPlease rename the file(s) and try again.", {
                    autoClose: 10000,
                    toastId: constants_1.UPLOAD_ADD_FAIL
                });
            }
            return __assign(__assign({}, state), { stagedFiles: __spreadArray(__spreadArray([], newlySelectedFiles), state.stagedFiles) });
        }
        case typesafe_actions_1.getType(transfersActions.setConnectVersion): {
            if (action.payload !== state.connectVersion) {
                return __assign(__assign({}, state), { connectVersion: action.payload });
            }
            return state;
        }
        case typesafe_actions_1.getType(transfersActions.setHttpGatewayStatus):
            return __assign(__assign({}, state), { httpGatewayStatus: action.payload });
        case typesafe_actions_1.getType(transfersActions.showAsperaInstall):
            return __assign(__assign({}, state), { asperaInstallVisible: true, extensionInstallStatus: action.payload.extensionStatus, extensionInstallUrl: action.payload.extensionUrl });
        case typesafe_actions_1.getType(transfersActions.showAsperaVersionBanner):
            return __assign(__assign({}, state), { asperaVersionBannerVisible: true });
        case typesafe_actions_1.getType(transfersActions.storeTransfer): {
            if (!action.payload.packageId) {
                return state;
            }
            var transfers = state.asperaTransfers;
            var packageTransfersList = transfers.get(action.payload.packageId) || immutable_1.OrderedMap();
            packageTransfersList = packageTransfersList.set(action.payload.transferId ? action.payload.transferId : '', action.payload);
            transfers = transfers.set(action.payload.packageId, packageTransfersList);
            return __assign(__assign({}, state), { asperaTransfers: transfers });
        }
        // React Router actions
        case connected_react_router_1.LOCATION_CHANGE: {
            return __assign(__assign({}, state), { selectedRemoteSource: -1, transferErrorMessage: '', transferSuccessMessage: '' });
        }
        default:
            return state;
    }
};
exports.transfersReducer = transfersReducer;
